<template>
  <el-button type='primary' @click='exportMD' icon='sys sys-export' class='navbarbtn'> 导 出</el-button>
</template>

<script>
export default {
  name: 'ExportExcel',
  props: {
  },

  methods: {
    // 导出按钮方法
    exportMD: function () {
      this.$emit('click')
    }
  }
}
</script>
